// extracted by mini-css-extract-plugin
export default {"searchBtn":"Dashboard_searchBtn__Ar4sM","searchClearBtn":"Dashboard_searchClearBtn__J-yO1"};